<template>
  <gg-card>
    <gg-card-header>
      Color Selection
    </gg-card-header>
    <gg-card-text>
      <v-row>
        <v-col cols="12">
          <v-dialog v-model="dialogColorPrimary" width="300">
              <v-color-picker v-model.lazy="colorPrimary" mode="hexa" />
          </v-dialog>
          <v-dialog v-model="dialogColorSecondary" width="300">
            <v-color-picker v-model.lazy="colorSecondary" mode="hexa" />
          </v-dialog>
          <v-dialog v-model="dialogColorLink" width="300">
            <v-color-picker v-model.lazy="colorLink" mode="hexa" />
          </v-dialog>

          <v-item-group active-class="primary">
            <v-row>
              <v-col cols="12" md="4">
                Please select a primary color for your theme.
                <v-item v-slot="{ active, toggle }">
                  <v-card class="app-card d-flex align-center" height="230" :color="colorPrimary">
                    <v-card-text class="text-center">
                      <gg-btn class="mt-5" tile color="primary" @click="openColorPicker('dialogColorPrimary')">
                        {{ active ? 'Selected' : 'Select' }}
                      </gg-btn>
                    </v-card-text>
                  </v-card>
                </v-item>
              </v-col>
              <v-col cols="12" md="4">
                Please select a secondary color for your theme.
                <v-item v-slot="{ active, toggle }">
                  <v-card class="app-card d-flex align-center" height="230" :color="colorSecondary">
                    <v-card-text class="text-center">
                      <gg-btn class="mt-5" tile color="primary" @click="openColorPicker('dialogColorSecondary')">
                        {{ active ? 'Selected' : 'Select' }}
                      </gg-btn>
                    </v-card-text>
                  </v-card>
                </v-item>
              </v-col>
              <v-col cols="12" md="4">
                Please select a link color for your theme.
                <v-item v-slot="{ active, toggle }">
                  <v-card class="app-card d-flex align-center" height="230" :color="colorLink">
                    <v-card-text class="text-center">
                      <gg-btn class="mt-5" tile color="primary" @click="openColorPicker('dialogColorLink')">
                        {{ active ? 'Selected' : 'Select' }}
                      </gg-btn>
                    </v-card-text>
                  </v-card>
                </v-item>
              </v-col>
            </v-row>
          </v-item-group>

        </v-col>
      </v-row>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'

export default {
  name: 'ColorSelection',
  data: () => ({
    dialogColorPrimary: false,
    dialogColorSecondary: false,
    dialogColorLink: false,
  }),
  computed: {
    ...mapGetters({
      starterSite: 'wizard_model/starterSite'
    }),
    colorPrimary: {
      get () {
        return this.starterSite.colorPrimary
      },
      set (color) {
        this.setPrimaryColor(color)
      }
    },
    colorSecondary: {
      get () {
        return this.starterSite.colorSecondary
      },
      set (color) {
        this.setSecondaryColor(color)
      }
    },
    colorLink: {
      get () {
        return this.starterSite.colorLink
      },
      set (color) {
        this.setLinkColor(color)
      }
    }
  },
  methods: {
    ...mapMutations({
      setPrimaryColor: 'wizard_model/SET_PRIMARY_COLOR',
      setSecondaryColor: 'wizard_model/SET_SECONDARY_COLOR',
      setLinkColor: 'wizard_model/SET_LINK_COLOR',
    }),
    openColorPicker (colorType) {
      this[colorType] = true
    },
  }
}
</script>

<style lang="scss" scoped>
.color-picker {
  //display: none;
}
</style>
